import React, { useState, useEffect } from 'react'
import { Typography, withStyles, Collapse, IconButton } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import { CoreTextField } from 'src/components/core'

const HeaderSettingsLanguageAccordion = ({
  classes,
  onButtonTextChange,
  isLoading,
  landingPageData,
  selectedStartValue,
  selectedResumeValue,
  selectedReadMoreValue,
  previewType,
  pageUrl,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  // Dynamic default values based on page type
  const defaultStartText =
    pageUrl === 'mini-course' ? 'Start Course' : 'Get Started'
  const defaultResumeText = 'Resume Course'
  const defaultReadMoreText = 'See more'

  const [resumeText, setResumeText] = useState(defaultResumeText)
  const [startText, setStartText] = useState(defaultStartText)
  const [readMoreText, setReadMoreText] = useState(defaultReadMoreText)

  useEffect(() => {
    setResumeText(
      landingPageData?.localizations?.resumeButton || defaultResumeText,
    )
    setStartText(
      landingPageData?.localizations?.startButton || defaultStartText,
    )
    setReadMoreText(
      landingPageData?.localizations?.readMore || defaultReadMoreText,
    )
  }, [
    landingPageData,
    defaultStartText,
    defaultResumeText,
    defaultReadMoreText,
  ])

  // Update local state when props change
  useEffect(() => {
    setStartText(selectedStartValue)
    setResumeText(selectedResumeValue)
    setReadMoreText(selectedReadMoreValue)
  }, [selectedStartValue, selectedResumeValue, selectedReadMoreValue])

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  const handleChangeResumeCourse = value => {
    setResumeText(value)
    onButtonTextChange('resume', value)
  }

  const handleChangeStartCourse = value => {
    setStartText(value)
    onButtonTextChange('start', value)
  }

  const handleChangeReadMore = value => {
    setReadMoreText(value)
    onButtonTextChange('readMore', value)
  }

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer} onClick={handleToggleExpanded}>
        <Typography className={classes.header}>Language</Typography>
        <IconButton
          className={classes.expandButton}
          onClick={handleToggleExpanded}
          size="small"
        >
          <Icon
            icon={
              isExpanded
                ? 'material-symbols:keyboard-arrow-up'
                : 'material-symbols:keyboard-arrow-down'
            }
            className={classes.expandIcon}
          />
        </IconButton>
      </div>

      <Collapse
        in={isExpanded}
        timeout="auto"
        unmountOnExit
        className={classes.collapse}
      >
        <div className={classes.content}>
          <CoreTextField
            value={resumeText}
            onChange={e => handleChangeResumeCourse(e.target.value)}
            fullWidth
            label={defaultResumeText}
            placeholder={defaultResumeText}
            disabled={isLoading}
          />

          <CoreTextField
            value={startText}
            onChange={e => handleChangeStartCourse(e.target.value)}
            fullWidth
            label={defaultStartText}
            placeholder={defaultStartText}
            disabled={isLoading}
          />

          {/* See More button - Only show for type 2 (Hero) */}
          {previewType === 2 && (
            <CoreTextField
              value={readMoreText}
              onChange={e => handleChangeReadMore(e.target.value)}
              fullWidth
              label={defaultReadMoreText}
              placeholder={defaultReadMoreText}
              disabled={isLoading}
            />
          )}
        </div>
      </Collapse>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsLanguageAccordion)
